<mat-card>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">

        <h2 class="mat-card-title-custom mt-3">
            {{ 'labor_contract_standardize.title_standardize_contract' | translate }}
        </h2>
        
        <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange($event)" class="tab-standardize">

            <!-- ============ TAB 1: Rà soát HĐLĐ cần chuẩn hóa ============ -->
            <mat-tab label="{{ 'labor_contract_standardize.tab_review' | translate }}">
                <ng-template matTabContent>
                    <div class="menu_tab_1">
                   

                    <div class="d-flex justify-content-center pt-3 pb-2">
                        <button mat-flat-button type="button" class="btn-add-review-list"
                            appTrackEvent="w.btn.hd_chuan_hoa.them_vao_danh_sach_ra_soat"
                            (click)="onAddToReviewList()">
                            <mat-icon class="mr-0">check_circle_outline</mat-icon>
                            {{ 'labor_contract_standardize.btn_add_to_review_list' | translate }}
                        </button>
                    </div>

                    <div class="alert-info-box mb-3" style="font-size: 14px;">
                        {{ 'labor_contract_standardize.review_description' | translate }}
                    </div>

                    <!-- Filter -->
                    <mat-accordion #accordion="matAccordion" [multi]="true">
                        <mat-expansion-panel expanded="true" class="mt-3">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="mat-panel-title">
                                    {{ 'search_form_standardize.ttl_search' | translate }}
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <form #myForm="ngForm" class="pb-3" (keydown.enter)="onSearch()">
                                <div class="row">

                                    <!-- Tên / Mã hợp đồng văn bản -->
                                    <div class="col-lg-3 col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>{{ 'search_form_standardize.contract_code_name' | translate }}
                                            </mat-label>
                                            <input type="text"
                                            (focusout)="documents.contractCode = documents.contractCode ? documents.contractCode.trim() : ''"
                                            #focusInput matInput
                                            name="contractCode" [(ngModel)]="documents.contractCode" maxlength="255"
                                            autocomplete="off">
                                            <button mat-button *ngIf="documents.contractCode" type="button" matSuffix
                                                mat-icon-button aria-label="Clear" (click)="documents.contractCode=''">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                        </mat-form-field>
                                    </div>

                                    <!-- Loại hợp đồng/văn bản: combobox hỗ trợ gõ tìm kiếm trong danh sách -->
                                    <div class="col-lg-3 col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>{{ 'search_form_standardize.contract_type' | translate }}
                                            </mat-label>
                                            <mat-select #contractTypeSelect name="contractType"
                                                [(ngModel)]="documents.contractType"
                                                (openedChange)="onContractTypeSelectOpenChange($event)"
                                                (selectionChange)="onContractTypeChange()">
                                                <div class="select-search-box" (click)="$event.stopPropagation()">
                                                    <input #contractTypeSearchInput type="text" class="select-search-input" 
                                                    [placeholder]="'common.search_placeholder' | translate"                                               
                                                    [(ngModel)]="contractTypeSearchText" name="contractTypeSearch"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (input)="onContractTypeSearchChange()"
                                                    (keydown)="$event.stopPropagation()"
                                                    style="padding-inline: 15px !important;">
                                                </div>
                                                <mat-option value="">{{ 'common.all' | translate }}</mat-option>
                                                <mat-option *ngFor="let item of filteredContractTypeOptions | async"
                                                    [value]="item.id">
                                                    {{ item.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <!-- Trạng thái rà soát -->
                                    <div class="col-lg-3 col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>{{ 'search_form_standardize.review_status' | translate }}
                                            </mat-label>
                                            <mat-select name="reviewStatus" [(ngModel)]="documents.reviewStatus"
                                            (selectionChange)="onContractTypeChange()">
                                                <mat-option value="">{{ 'common.all' | translate }}</mat-option>
                                                <mat-option *ngFor="let item of reviewStatusOptions"
                                                    [value]="item.value">
                                                    {{ item.label }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <!-- Trạng thái chuẩn hóa -->
                                    <div class="col-lg-3 col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>{{ 'search_form_standardize.standardize_status' | translate }}
                                            </mat-label>
                                            <mat-select name="standardizeStatus"
                                                [(ngModel)]="documents.standardizeStatus"  
                                                (selectionChange)="onContractTypeChange()">
                                                <mat-option value="">{{ 'common.all' | translate }}</mat-option>
                                                <mat-option *ngFor="let item of standardizeStatusOptions"
                                                    [value]="item.value">
                                                    {{ item.label }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                </div>

                                <div class="row mt-4">
                                    <div class="col-lg-12 d-flex justify-content-center">
                                        <button mat-stroked-button color="primary" type="button"
                                            appTrackEvent="w.btn.hd_chuan_hoa.tim_kiem"
                                            (click)="onSearch()">
                                            <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                                            {{ 'enterprise_contract.buttons.search' | translate }}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </mat-expansion-panel>
                    </mat-accordion>

                    <!-- Danh sách hợp đồng/văn bản: tiêu đề + bảng + pagination trong một khối viền trắng -->
                    <div class="contract-list-panel mt-3 mb-2">

                        <div class="d-flex align-items-center list-header">
                            <span class="table-title">
                                {{ 'labor_contract_standardize.contract_list' | translate }}
                                <span class="text-danger">({{ totalRecords }})</span>
                                <!-- {{ 'labor_contract_standardize.selected' | translate }}:
                                <span class="text-danger">{{ selection.selected.length }}</span> -->
                            </span>
                        </div>

                        <div class="mat-table-container" style="display: block; max-height: 590px; position: relative; overflow: auto">
                        <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
                            class="mat-table-col-extra-sm">

                            <!-- select -->
                            <!-- <ng-container matColumnDef="select">
                                <mat-header-cell *matHeaderCellDef
                                    class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                                    <mat-checkbox *ngIf="dataSource && dataSource.data && dataSource.data.length"
                                        (change)="$event ? masterToggle() : null"
                                        [checked]="selection.hasValue() && isAllSelected()" color="primary">
                                    </mat-checkbox>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                                    (click)="$event.stopPropagation()">
                                    <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                                        (change)="$event ? addListRecord(element) : null"
                                        [checked]="selection.isSelected(element.idNotify)">
                                    </mat-checkbox>
                                </mat-cell>
                            </ng-container> -->

                            <!-- STT -->
                            <ng-container matColumnDef="stt">
                                <mat-header-cell *matHeaderCellDef
                                    class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                                    {{ 'labor_contract_standardize.table_headers.no' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                                    <span class="fix-width">{{ element.stt }}</span>
                                </mat-cell>
                                <mat-footer-cell *matFooterCellDef class="no-col skeleton-footer-cell">
                                    <span class="skeleton-cell"></span>
                                  </mat-footer-cell>
                            </ng-container>

                            <!-- Mã - Tên hợp đồng/văn bản: BE trả sẵn đã ghép -->
                            <ng-container matColumnDef="codeName">
                                <mat-header-cell *matHeaderCellDef mat-sort-header
                                    class="mat-cell-non-boder-right-bottom">
                                    {{ 'labor_contract_standardize.table_headers.contract_code_name' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" [matTooltip]="element.codeName" class="mat-cell-non-boder-right-bottom">
                                    <span class="fix-width">{{ element.codeName }}</span>
                                </mat-cell>
                                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                                    <span class="skeleton-cell"></span>
                                  </mat-footer-cell>
                            </ng-container>

                            <!-- Loại hợp đồng -->
                            <ng-container matColumnDef="contractType">
                                <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
                                    {{ 'labor_contract_standardize.table_headers.contract_type' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" [matTooltip]="element.contractType" class="mat-cell-non-boder-right-bottom">
                                    <span class="fix-width">{{ element.contractType }}</span>
                                </mat-cell>
                                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                                    <span class="skeleton-cell"></span>
                                  </mat-footer-cell>
                            </ng-container>

                            <!-- Các bên ký kết -->
                            <ng-container matColumnDef="signers">
                                <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
                                    {{ 'labor_contract_standardize.table_headers.signers' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" [matTooltip]="element.signers"
                                    class="mat-cell-non-boder-right-bottom">
                                    <span class="fix-width">{{ element.signers }}</span>
                                </mat-cell>
                                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                                    <span class="skeleton-cell"></span>
                                  </mat-footer-cell>
                            </ng-container>

                            <!-- Trạng thái rà soát -->
                            <ng-container matColumnDef="reviewStatus">
                                <mat-header-cell *matHeaderCellDef
                                    class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                    {{ 'labor_contract_standardize.table_headers.review_status' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                    <nz-tag *ngIf="element.reviewStatus" [nzColor]="getStatusTagColor(element.reviewStatus)" style="margin-right: 0px;">
                                        {{ 'labor_contract_standardize.review_status.' + element.reviewStatus |
                                            translate }}
                                    </nz-tag>
                                </mat-cell>
                                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                                    <span class="skeleton-cell"></span>
                                  </mat-footer-cell>
                            </ng-container>

                            <!-- Trạng thái CKS NSDLĐ -->
                            <ng-container matColumnDef="cksNsdldStatus">
                                <mat-header-cell *matHeaderCellDef
                                    class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                    {{ 'labor_contract_standardize.table_headers.cks_nsdld_status' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                    <nz-tag *ngIf="element.cksNsdldStatus" [nzColor]="getStatusTagColor(element.cksNsdldStatus)" style="margin-right: 0px;">
                                        {{ 'labor_contract_standardize.cks_status.' + element.cksNsdldStatus |
                                            translate }}
                                    </nz-tag>
                                </mat-cell>
                                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                                    <span class="skeleton-cell"></span>
                                  </mat-footer-cell>
                            </ng-container>

                            <!-- Trạng thái CKS NLĐ -->
                            <ng-container matColumnDef="cksNldStatus">
                                <mat-header-cell *matHeaderCellDef
                                    class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                    {{ 'labor_contract_standardize.table_headers.cks_nld_status' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                    <nz-tag *ngIf="element.cksNldStatus" [nzColor]="getStatusTagColor(element.cksNldStatus)" style="margin-right: 0px;">
                                        {{ 'labor_contract_standardize.cks_status.' + element.cksNldStatus |
                                            translate }}
                                    </nz-tag>
                                </mat-cell>
                                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                                    <span class="skeleton-cell"></span>
                                  </mat-footer-cell>
                            </ng-container>

                            <!-- Trạng thái bổ sung thông tin HĐLĐ -->
                            <ng-container matColumnDef="additionalInfoStatus">
                                <mat-header-cell *matHeaderCellDef
                                    class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                    {{ 'labor_contract_standardize.table_headers.additional_info_status' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                    <nz-tag *ngIf="element.additionalInfoStatus" [nzColor]="getStatusTagColor(element.additionalInfoStatus)" style="margin-right: 0px;">
                                        {{ 'labor_contract_standardize.additional_info_status.' +
                                            element.additionalInfoStatus | translate }}
                                    </nz-tag>
                                </mat-cell>
                                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                                    <span class="skeleton-cell"></span>
                                  </mat-footer-cell>
                            </ng-container>

                            <!-- Trạng thái chuẩn hóa -->
                            <ng-container matColumnDef="standardizeStatus">
                                <mat-header-cell *matHeaderCellDef
                                    class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                    {{ 'labor_contract_standardize.table_headers.standardize_status' | translate }}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                    <nz-tag *ngIf="element.standardizeStatus" [nzColor]="getStatusTagColor(element.standardizeStatus)" style="margin-right: 0px;">
                                        {{ 'labor_contract_standardize.standardize_status.' +
                                            element.standardizeStatus | translate }}
                                    </nz-tag>
                                </mat-cell>
                                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                                    <span class="skeleton-cell"></span>
                                  </mat-footer-cell>
                            </ng-container>

                            <!-- Ghi chú: text "xem thêm" mở popup danh sách ghi chú -->
                            <ng-container matColumnDef="note">
                               <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom justify-content-center text-center">
                                  {{ 'labor_contract_standardize.table_headers.note' | translate }}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom justify-content-center text-center">
                                 <span class="link-note" (click)="openNoteDialog(element)">{{
                                     'labor_contract_standardize.btn_view_more' | translate }}</span>
                             </mat-cell>
                             <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                                <span class="skeleton-cell"></span>
                              </mat-footer-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                            <mat-footer-row *matFooterRowDef="displayedColumns"
                                class="table-skeleton-row"
                                [class.table-skeleton-hidden]="!isLoading"></mat-footer-row>
                        </mat-table>

                        <div *ngIf="!isLoading && (!dataSource.data || dataSource.data.length === 0)" class="text-center py-4">
                            {{ 'common.no_data' | translate }}
                          </div>
                        </div>

                        <!-- Pagination (component common của hệ thống) -->
                        <app-pagination *ngIf="paginate?.totalRow > 0" (pageChange)="onChangePage($event)" [(paginate)]="paginate"></app-pagination>
                    </div>
                </div>
                </ng-template>
            </mat-tab>

            <!-- ============= TAB 2: Thực hiện chuẩn hóa ============= -->
            <mat-tab label="{{ 'labor_contract_standardize.tab_standardize' | translate }}">
                <ng-template matTabContent>
                    <app-labor-contract-standardize-execute></app-labor-contract-standardize-execute>
                </ng-template>
            </mat-tab>

        </mat-tab-group>

    </mat-card-content>
</mat-card>